import React, { useEffect } from 'react';
import {Link} from 'react-router-dom';
import { Button } from 'antd';
import { FormattedMessage } from "react-intl";
import create_tour from '../../../../../static/img/ts_menu_rideplan.png';

const EmptyTabList = ({hasButton=true}) => {

    return <div className="emptyTabList">

        <img src={create_tour}/>

        <div className="emptyListContent">
            <span><FormattedMessage id="No tour to download" defaultMessage="No tour to download"/></span>
            {hasButton &&
            <Link to="/createtour">
                <Button type='primary' size='small'><span><FormattedMessage id="Create tour" defaultMessage="Create tour"/></span></Button>
            </Link>}
        </div>

    </div>
}

export const ListWithoutUser = ({showLogin}) => {
    // useEffect(()=>{    //use to launch login imidiatelly if it needs
    //     setTimeout(()=>{
    //         showLogin(true);
    //     }, 200);
    // }, []);

    return <div className="emptyTabList">

        <img src={create_tour}/>

        <div className="emptyListContent">
            <span><FormattedMessage id="Login to get these tours" defaultMessage="Login to get these tours"/></span>
        </div>

    </div>
}

export default EmptyTabList
